import React from 'react';

interface Props {
  image: string;
  title: string;
  subtitle?: string;
  children?: React.ReactNode;
}

// Consistent, premium empty state: illustration on a soft glow, refined
// heading + supporting line, and room for an optional call to action.
const EmptyState: React.FC<Props> = ({ image, title, subtitle, children }) => (
  <div className="flex flex-col items-center justify-center text-center py-10 px-6">
    <div className="relative mb-5">
      <div className="absolute inset-0 m-auto h-24 w-24 rounded-full bg-emerald-400/20 blur-3xl" />
      <img src={image} alt="" className="relative w-36 h-36 object-contain" />
    </div>
    <h3 className="text-lg font-bold text-gray-900">{title}</h3>
    {subtitle && <p className="text-sm text-gray-500 mt-1.5 max-w-[17rem] leading-relaxed">{subtitle}</p>}
    {children && <div className="mt-6 w-full flex justify-center">{children}</div>}
  </div>
);

export default EmptyState;
